import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface HistoricalReportData {
  opportunityNumbers: string[];
  debtorNames: string[];
  vins: string[];
}

const initialState: HistoricalReportData = {
  opportunityNumbers: [],
  debtorNames: [],
  vins: [],
};

const historicalReportSlice = createSlice({
  name: "historicalReport",
  initialState,
  reducers: {
    setHistoricalReportData: (
      state,
      action: PayloadAction<Partial<HistoricalReportData>>
    ) => {
      if (action.payload.opportunityNumbers) {
        state.opportunityNumbers = action.payload.opportunityNumbers;
      }
      if (action.payload.debtorNames) {
        state.debtorNames = action.payload.debtorNames;
      }
      if (action.payload.vins) {
        state.vins = action.payload.vins;
      }
    },
    clearHistoricalReportData: (state) => {
      state.opportunityNumbers = [];
      state.debtorNames = [];
      state.vins = [];
    },
  },
});

export const { setHistoricalReportData, clearHistoricalReportData } =
  historicalReportSlice.actions;

export default historicalReportSlice.reducer;
